/* istanbul ignore file */

import { createGetTextResources } from "../../shared/utils/text-resources-algemeen";

export const getAoTextResources = createGetTextResources({
  TooltipToetsjaarTekort:
    "Het toetsjaar is het jaar vanaf passerdatum/ingangsdatum, waarbij het jaar van passeren (ingaan) meetelt als jaar 1. Je kunt het toetsjaar aanpassen in de instellingen-app, op het scherm ‘Adviesinstellingen - Uitgangspunten advies’."
});
